// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_TOKEN = '@customization/SET_TOKEN';
export const SET_USER_DATA = '@customization/SET_USER_DATA';
export const SET_AUTHENTICATED = '@customization/SET_AUTHENTICATED';
